import { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Modal, ModalBody, ModalFooter, Button, TableView, Tooltip } from "@gpstrackit/react-controls";
import { getTransactionsProcessingStatusColor } from 'Core/data/Helpers';
import { Chip, IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import CustomCard from 'Components/Card';
import RefreshIcon from '@mui/icons-material/Refresh';
import ChipStatus from 'Components/ChipStatus';

//Actions
import { transactionsDetailsRequest, transactionsDetailsCloseModal, dataDetailsOpenModal, clearRedux } from 'Redux/actions';

//Views
import DataDetails from '../../.components/dataDetails'

//Styles
import './results.scss'

const transactionsDetails = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const tableViewRef = useRef();

    //Redux States
    const { openModal, transactions, loading, nextToken, transactionId, type } = useSelector(state => state.transactionsDetailsRedux);
    const openModalDataDetails = useSelector(state => state.dataDetailsRedux.openModal);

    const closeModal = () => {
        dispatch(transactionsDetailsCloseModal());
        dispatch(clearRedux("TRANSACTIONS_DETAILS"))
    }

    const transactionsHandler = (newTime, newTags, refresh) => {
        if (refresh) {
            dispatch(clearRedux("TRANSACTIONS_DETAILS", { nextToken: null, transactions: [] }));
        }

        let payload = {
            transactionId: transactionId,
            type: type
        }
        if (nextToken && !newTime && !newTags && !refresh) {
            payload.nextToken = nextToken
        }

        !nextToken && !refresh && dispatch(clearRedux("TRANSACTIONS_DETAILS", { transactions: [] }))
        dispatch(transactionsDetailsRequest(payload))
    }

    useEffect(() => {
        let payload = {
            transactionId: transactionId,
            type: type,
            nextToken: null
        }
        dispatch(transactionsDetailsRequest(payload))
        return () => {
            closeModal()
        }
    }, []);
    return (
        <Modal
            open={openModal}
            title={`${messages['transactions_details_title']} ${type ? `- ${type}` : ""}`}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div className="container-transaction-table">
                    <div>
                        <Tooltip title={messages['refresh']}>
                            <IconButton style={{ padding: 0, marginLeft: 5 }} onClick={() => transactionsHandler(null, null, true)} size="large">
                                <RefreshIcon style={{ color: 'black', fontSize: 20 }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <TableView
                        ref={tableViewRef}
                        data={transactions || []}
                        loading={loading}
                        page={0}
                        rowsPerPage={10}
                        topSpaceSize={227}
                        infiniteScroll={true}
                        viewType="list"
                        messages={messages}
                        serverSide
                        itemSelector={false}
                        onChangePage={(newPage) => {
                            transactionsHandler()
                        }}
                        moreRowsAvailable={nextToken}
                        renderRow={(item) => {
                            let to = null
                            let data = null
                            const message = item?.Message ? item?.Message?.replace("CustomException:", "") : item?.errorMsg
                            try {
                                data = JSON.parse(item?.Data);
                                if (data?.to?.length) {
                                    data?.to.map((item) => {
                                        to = item?.recipients?.[0]?.to;
                                    })
                                }
                            } catch (error) { }

                            if (item?.Type === "Resync" && data?.entities?.length) {
                                return <></>
                            }

                            let status = (type !== "ReprocessOdoHrs" && type !== "RecalculateOdometerHours") ? ((item.Message && item?.Type !== "Resync") ? getTransactionsProcessingStatusColor("FAILURE") : getTransactionsProcessingStatusColor(item?.Status)) : (item.errorMsg ? getTransactionsProcessingStatusColor("FAILURE") : getTransactionsProcessingStatusColor(item?.processed ? "Processed" : "Pending"))

                            return (
                                <CustomCard
                                    customIcon={() => <InfoIcon />}
                                    customMessage={messages['transactions_details_show_data']}
                                    onClick={() => dispatch(dataDetailsOpenModal(item?.Data))}
                                    width={11}
                                    minWithIcon={1}
                                    styles={{ margin: 5 }}
                                    hideButton={(type === "ReprocessOdoHrs" || type === "RecalculateOdometerHours" || type === "Resync")}
                                >
                                    <div style={{ display: 'grid', width: '100%' }}>
                                        <div>
                                            {
                                                (data?.esn || data?.unit?.esn) && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_esn']}</label><span>{data?.esn || data?.unit?.esn}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                (item?.unitId) && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_unit']}</label><span>{item.unitId}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                (data?.unitIds && data?.unitIds.length > 0) && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_units']}</label>
                                                        <span>{data.unitIds.join(', ')}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                (data?.status) &&(
                                                    <div style={{ marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_status_changed']}</label>
                                                        <ChipStatus statusCode={data?.status} messages={messages} />
                                                    </div>
                                                )
                                            }
                                            {
                                                (data?.type && data?.label) && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_name']}</label><span>{data?.label}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                data?.type &&
                                                <div style={{ marginBottom: 2 }}>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_type']}</label><span>{messages[`transactions_details_type_${data?.type}`] || data?.type}</span>
                                                </div>
                                            }
                                            {
                                                data?.hardwareVersion && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_hardwareVersion']}</label><span>{data.hardwareVersion}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                type === "DiagnosticUnits" && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_unit']}</label><span>{data}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                to && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_to']}</label><span>{to}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                status && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_status']}</label>
                                                        <Chip
                                                            label={messages[status?.label]}
                                                            size="small"
                                                            style={{
                                                                backgroundColor: status?.color,
                                                                color: "#ffffff"
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            {
                                                message && (
                                                    <div style={{ marginBottom: 2 }}>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['transactions_details_message']}</label><span>{message}</span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }}
                    />
                </div>
                {openModalDataDetails && <DataDetails type={type} />}
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default transactionsDetails;